import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { TransporterImportModel } from 'src/app/models/imports/transporter-import-model';
import { environment } from 'src/environments/environment';
import { TransporterUpdateDocumentModel } from './../../models/archive/transporter-update-document.model';
import { TransporterModel } from './../../models/archive/transporter.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';

@Injectable({
  providedIn: 'root'
})
export class TransporterService {

  constructor(private _httpClient: HttpClient) { }

  createTransporter(TransporterContract: TransporterModel): Observable<TransporterModel> {
    return this._httpClient.post<TransporterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.CreateTransporter}`,
      TransporterContract);
  }

  deleteTransporter(transporterId: number): Observable<TransporterModel> {
    return this._httpClient.delete<TransporterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.DeleteTransporter}/${transporterId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllTransportersForSelectAsync(branchId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.GetAllTransportersForSelectAsync}/${branchId}`,);
  }

  getAllTransportersWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.GetAllTransportersWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllTypeDocumentsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.GetAllTypeDocumentsForSelectAsync}`,);
  }

  getDigitVerification(document: string): Observable<number> {
    const itemFilterResponse = new ItemFilterModel("document", null, null, "");
    itemFilterResponse.wildcard = document;
    return this._httpClient.post<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.GetDigitVerification}`, itemFilterResponse);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.GetColumnsForGeneralConsultationAsync}`);
  }

  getTransporterByBranchId(branchId: number): Observable<Array<TransporterModel>> {
    return this._httpClient.get<Array<TransporterModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.GetTransporterByBranchId}/${branchId}`);
  }

  getTransporterByDocumentAsync(branchId: number, document: string): Observable<TransporterModel> {
    const itemFilterResponse = new ItemFilterModel("document", branchId, null, "");
    itemFilterResponse.wildcard = document;
    return this._httpClient.post<TransporterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.GetTransporterByDocumentAsync}`, itemFilterResponse)
  }

  getTransporterById(transporterId: number): Observable<TransporterModel> {
    return this._httpClient.get<TransporterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.GetTransporterById}/${transporterId}`);
  }

  getTransporterByName(branchId: number, name: string): Observable<TransporterModel> {
    const itemFilterResponse = new ItemFilterModel("name", branchId, null, "");
    itemFilterResponse.wildcard = name;
    return this._httpClient.post<TransporterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.GetTransporterByName}`, itemFilterResponse)
  }

  importTransporters(transporterImports: Array<TransporterImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.ImportTransporter}`, transporterImports);
  }

  setActiveTransporter(transporterId: number): Observable<TransporterModel> {
    return this._httpClient.put<TransporterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.SetActiveTransporter}/${transporterId}`,
      null);
  }

  updateTransporter(TransporterContract: TransporterModel): Observable<TransporterModel> {
    return this._httpClient.put<TransporterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.UpdateTransporter}`,
      TransporterContract);
  }

  updateTransporterDocument(TransporterContract: TransporterUpdateDocumentModel): Observable<TransporterModel> {
    return this._httpClient.put<TransporterModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transporter.UpdateTransporterDocument}`,
      TransporterContract);
  }
}
